import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import PropTypes from 'prop-types';
import * as TwoFactorAuthSetupSteps from '../constants/TwoFactorAuthSetupSteps';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import PhoneNumberInput from 'ui-addon-i18n/components/PhoneNumberInput';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import Small from 'UIComponents/elements/Small';
import debounce from 'react-utils/debounce';
import TwoFactorAuthSMSErrors from '../constants/TwoFactorAuthSMSErrors';
import { jsx as _jsx } from "react/jsx-runtime";
const DEBOUNCE_TIME = 2000;
const PhoneNumberValidation = props => {
  const {
    error,
    number,
    onKeyUp
  } = props;
  const showError = error !== undefined;
  const handleNumberChange = phoneData => {
    const {
      phoneNumber
    } = phoneData;
    if (phoneNumber && phoneNumber.length > 4) {
      props.onNumberChange(phoneNumber);
    }
  };
  const debounced = debounce(handleNumberChange, DEBOUNCE_TIME, this);
  return /*#__PURE__*/_jsx(UIFormControl, {
    error: showError,
    label: /*#__PURE__*/_jsx(UIFormLabel, {
      htmlFor: "phone-number",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `userPreferences.2fa.CHOOSE_METHOD.smsOptionLabel`
      })
    }),
    validationMessage: showError && /*#__PURE__*/_jsx(Small, {
      "data-test-id": "validation-message",
      use: "error",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `userPreferences.2fa.${TwoFactorAuthSetupSteps.REGISTER_SMS}.error.${error}`
      })
    }),
    children: /*#__PURE__*/_jsx(PhoneNumberInput, {
      phoneInputProps: {
        id: 'phone-number',
        className: 'width-100',
        error: showError
      },
      countrySelectProps: {
        error: showError
      },
      value: number,
      onChange: debounced,
      onKeyUp: onKeyUp,
      "data-test-id": "2fa-phone-number-input"
    })
  });
};
PhoneNumberValidation.propTypes = {
  onNumberChange: PropTypes.func.isRequired,
  error: PropTypes.oneOf(Object.keys(TwoFactorAuthSMSErrors)),
  number: PropTypes.string.isRequired,
  onKeyUp: PropTypes.func.isRequired
};
export default PhoneNumberValidation;